import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./vuex/store";
import http from "./http";
import CKEditor from "@ckeditor/ckeditor5-vue";
import "./registerServiceWorker";
import "boxicons";
import { VueMaskDirective } from "v-mask";
// IMPORTAÇÃO DO BOOTSTRAP-VUE
import { BLink, BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "@/assets/vendor/bootstrap/css/bootstrap.min.css";
import "@/assets/vendor/icofont/icofont.min.css";
import "@/assets/vendor/boxicons/css/boxicons.min.css";
import "@/assets/vendor/owl.carousel/assets/owl.carousel.min.css";
import "@/assets/vendor/venobox/venobox.css";
import "@/assets/vendor/aos/aos.css";
import "@/assets/vendor/jquery/jquery.min.js";
import "@/assets/vendor/bootstrap/js/bootstrap.bundle.min.js";
import "@/assets/vendor/jquery.easing/jquery.easing.min.js";
import "@/assets/vendor/waypoints/jquery.waypoints.min.js";
import "@/assets/vendor/counterup/counterup.min.js";
import "@/assets/vendor/owl.carousel/owl.carousel.js";
import "@/assets/vendor/isotope-layout/isotope.pkgd.min.js";
import "@/assets/vendor/venobox/venobox.min.js";
import "vue-toastification/dist/index.css";
import AOS from "@/assets/vendor/aos/aos.js";
import Multiselect from "vue-multiselect";
import Toast from "vue-toastification";
// register jw pagination component globally
import JwPagination from "jw-vue-pagination";
import VueAnalytics from "vue-analytics";
import VueCompositionAPI from '@vue/composition-api'


Vue.component("b-link", BLink);

Vue.component("jw-pagination", JwPagination);

Vue.directive("mask", VueMaskDirective);
Vue.use(CKEditor);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.prototype.$http = http;
Vue.use(require("vue-moment"));
Vue.use(Toast, {});
AOS.init();
Vue.component("multiselect", Multiselect);
Vue.use(VueCompositionAPI)

Vue.use(VueAnalytics, {
  id: "UA-72959774-12",
  router
});

new Vue({
  router,
  store,
  render: h => h(App),
  created() { }
}).$mount("#app");
